import {useSimpleQuery} from '~/mercuryWebBackend/useSimpleQuery'
import {useReferrerData} from './useReferrerData'
import {api} from '~/mercuryWebBackend/api'
import {safely} from '../safely'
import {type PortableTextBlock} from '@portabletext/types'

// NOTE: Incomplete AND everything is possibly undefined to support draft mode
type PartnerData = {
  logos?: Array<{
    logoType?: 'dark' | 'light' | 'colored'
    logo?: any
  }>
  partnerLandingPageInfo?: {
    title?: string[]
    subtitle?: PortableTextBlock
    hideBanner?: boolean
  }
}

export type ReferrerSanityData = ReturnType<typeof useSanityReferrerData>
export function useSanityReferrerData() {
  const referrerData = useReferrerData()
  const query = useSimpleQuery(
    api.clientSanityLoggedOut,
    {documentType: 'partner'},
    {},
    {
      staleTime: Infinity,
      enabled: referrerData?.type === 'generatedPartner',
    }
  )

  if (!referrerData) return null
  if (referrerData.type !== 'generatedPartner') return {referrerData, partner: null}

  if (query.isPending) return null
  if (query.isError) return null

  const partner: PartnerData | null =
    safely(query.data, (data: any) =>
      data?.result?.find((item: any) => {
        return item.pageSlug?.current === referrerData.callsign
      })
    ) ?? null

  return {
    referrerData,
    partner,
  }
}
